import React, { Component } from 'react'
import { connect } from "react-redux"
import { URL } from "app/config/api-config"
import trans, { LangPrefixType } from "trans/index"

import { css, Grid, GridCell } from "@bdfx/mergado-ui-kit"

import {
    updateInputValue as change,
} from "app/reducers/form";

import { ShapeSet, ShapeSetFile } from "app/types/model-types";
import Shape, { BADGE_TYPE } from "shape-entities/types/shape"
import { ID, ReduxList } from "app/types/app-types";
import find from 'lodash/find';

import uniqueId from "app/helpers/unique_id";
import { getLocale } from "app/helpers/session";
import { getLangPrefixFromOutputFormat } from "trans/helpers";
import {  getFormName, getTemplateSize } from 'shape-edit/forms/helpers';
import { selectFormValues } from 'app/reducers/form';
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers';
import { setActiveShapeId } from 'shape-edit/reducers';
import ChangeSvgColors from 'shape-edit/forms/change-svg-colors'

interface Props {
    shapeIndex: string
    outputLangPrefix: LangPrefixType
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    shapeSets: ReduxList<ShapeSet[]>
    change: typeof change
    setActiveShapeId: typeof setActiveShapeId,
}

class SetFilesSelect extends Component<Props> {
    protected handleOnLoadDebounced
    protected canvasRef: Element
    protected currentRequest: XMLHttpRequest = null

    constructor(props) {
        super(props)

        this.canvasRef = document.querySelector('rect.preview-background')
    }

    componentWillUnmount() {
        if (this.currentRequest) {
            this.currentRequest.abort()
            this.currentRequest = null
        }
    }

    getCurrentShape = (): Shape => {
        const { shapeIndex, form } = this.props
        const shape = form.shapes[shapeIndex]
        return shape
    }

    getCurrentSet = () : ShapeSet => {
        const { shapeSets } = this.props
        const shape = this.getCurrentShape()

        return shape ? find(shapeSets.data, (set: ShapeSet) => {
                return set.id === shape.set_id
            }) : null
    }

    getCurrentFile = (): ShapeSetFile => {
        const shape = this.getCurrentShape()
        const currentSet = this.getCurrentSet()

        return currentSet && shape ? find(currentSet.files, (file: ShapeSetFile) => {
            return file.id === shape.set_file_id
        }) : null
    }

    addShape(setFile: ShapeSetFile, path: string, addNew: boolean = false) {
        const { form, isAlt, shapeIndex } = this.props

        const shape = this.getCurrentShape()
        const currentSet = this.getCurrentSet()

        const isFullScreen = ['borders', 'background', 'generic'].includes(currentSet.name) || setFile.filename.includes('frame')
        const newIndex = uniqueId()
        const templateSize = getTemplateSize()
        const formName = getFormName(isAlt)

        if (!shape) {
            console.debug(`not current shape ${shapeIndex}!!!!`)
            return;
        }

        const updatedShape: Shape = {
            ...shape,
            type: BADGE_TYPE,
            name: `${currentSet.name} ${setFile.filename}`,
            set: currentSet,
            set_id: setFile.set_id,
            set_file_id: setFile.id,
            width: isFullScreen ? templateSize.width : shape.width,
            height: isFullScreen ? templateSize.height : shape.height,
            imageBlob: `${URL.laravelBase}imagesets/${currentSet.name}/${setFile.filename}`,
        }

        if (setFile.mime_type === 'jpeg') {
            if (addNew) {
                let newShapes = [];
                newShapes[newIndex] = {
                    ...updatedShape,
                    index: newIndex,
                }

                this.props.change(formName, "shapes", { ...form.shapes, ...newShapes })
                this.props.setActiveShapeId(newIndex)
            } else {
                this.props.change(formName, `shapes.${shape.index}`, updatedShape);
            }
        } else {
            const targetIndex = addNew ? newIndex : shape.index
            updatedShape.index = targetIndex

            if (this.currentRequest) {
                this.currentRequest.abort()
            }

            const request = new XMLHttpRequest()
            this.currentRequest = request

            request.open("GET", path.replace('.png', '.svg'))
            request.setRequestHeader("Content-Type", "image/svg+xml")
            request.addEventListener("load", (event) => {
                this.currentRequest = null

                const eventTarget: any = event.target
                const svg = eventTarget.responseText;
                const doc = new DOMParser();
                const xml: XMLDocument = doc.parseFromString(svg, "image/svg+xml");

                let result = svg.slice(0, svg.indexOf("<svg"));
                result += xml.documentElement.outerHTML;

                const dataUri = "data:image/svg+xml," + encodeURIComponent(result)

                if (!isFullScreen) {
                    updatedShape.width = xml.rootElement.width.baseVal.value
                    updatedShape.height = xml.rootElement.height.baseVal.value

                    if (updatedShape.width && updatedShape.height && (templateSize.width < updatedShape.width || templateSize.height < updatedShape.height)) {
                        const c = templateSize.width < templateSize.height ? updatedShape.width / templateSize.width : updatedShape.height / templateSize.height
                        updatedShape.width = updatedShape.width / c
                        updatedShape.height = updatedShape.height / c
                    }
                }

                if (!updatedShape.width || !updatedShape.height) {
                    updatedShape.width = 250
                    updatedShape.height = 150

                    const img = new Image()
                    img.src = `${URL.laravelBase}imagesets/${currentSet.name}/${setFile.filename}`
                    img.onload = (event) => {
                        updatedShape.width = img.width
                        updatedShape.height = img.height
                        this.props.change(formName, `shapes.${targetIndex}`, updatedShape)
                    }
                    img.onerror = (event) => {
                        console.error('cannot load image', event)
                    }
                }

                updatedShape.imageBlob = dataUri;
                updatedShape.name = setFile.filename

                if (addNew) {
                    this.props.change(formName, "shapes", { ...this.props.form.shapes, [targetIndex]: updatedShape })
                    this.props.setActiveShapeId(targetIndex)
                } else {
                    this.props.change(formName, `shapes.${targetIndex}`, updatedShape);
                }
            });

            request.addEventListener("error", (event) => {
                this.currentRequest = null
                console.error('cannot load svg', path, event)
            });

            request.send();
        }
    }

    renderChosenSetFile() {
        const { outputLangPrefix } = this.props

        const shape = this.getCurrentShape()
        const currentSet = this.getCurrentSet()

        if (currentSet && shape) {
            const currentFile = this.getCurrentFile()

            if (currentFile) {
                const langKey = outputLangPrefix ? `${outputLangPrefix}_filename` : null
                const filename = langKey && currentFile[langKey] ? currentFile[langKey] : currentFile.filename

                const path = `${URL.publicPath}img/sets/${currentSet.name}/${filename}`
                const setFileId = shape.set_file_id

                return (
                    <StyledGrid cols={"1/-1"}>
                        <GridCell key={setFileId} className={'set-thumb big clickable'} title={`${currentFile.filename} - ${trans('change')}`}>
                            <img
                                src={path}
                                className={'checker'}
                                onLoad={this.handleOnLoadDebounced}
                                onDragEnd={(e) => {
                                    this.addShape(currentFile, path, true)
                                }}
                            />
                        </GridCell>
                    </StyledGrid>
                )
            }
        } else {
            console.debug('cannot find chosen file', shape.set_file_id, shape.set_id, currentSet)
        }

        return (
            <span />
        )
    }

    renderThumbnails() {
        const { outputLangPrefix, form } = this.props

        const locale = getLocale()
        const outputLangPrefix2 = getLangPrefixFromOutputFormat('.' + locale.slice(-2).toLowerCase())
        const currentSet = this.getCurrentSet()

        if (currentSet) {
            const thumbs = currentSet.files.map(setfile => {
                const langKey = outputLangPrefix ? `${outputLangPrefix}_filename` : null
                const filename = langKey && setfile[langKey] ? setfile[langKey] : setfile.filename
                const path = `${URL.publicPath}img/sets/${currentSet.name}/${filename}`

                const langKey2 = outputLangPrefix2 ? `${outputLangPrefix2}_filename` : null
                const filename2 = langKey2 && setfile[langKey2] ? setfile[langKey2] : setfile.filename
                const path2 = `${URL.publicPath}img/sets/${currentSet.name}/${filename2}`

                return (
                    <GridCell key={setfile.id} className={'set-thumb small'} title={`**${setfile.filename}**  ${setfile.tags}`}>
                        <img
                            src={path2}
                            className={'checker'}
                            onLoad={this.handleOnLoadDebounced}
                            onDragEnd={(e) => {
                                this.addShape(setfile, path, true)
                            }}
                            onClick={() => {
                                this.addShape(setfile, path)
                            }}
                        />
                    </GridCell>
                )
            })

            return (
                <StyledGrid cols="repeat(5, 1fr)" gap={"15px"}>
                    {thumbs}
                </StyledGrid>
            )
        }
    }

    render() {
        const { shapeIndex, form } = this.props

        const shape = form.shapes[shapeIndex]

        return (
            <div>
                {shape.imageBlob !== "" && shape.set_id && shape.set_file_id &&
                    this.renderChosenSetFile()
                }

                {(shape.set_id && shape.set_file_id) &&
                    <ChangeSvgColors shape={shape} />
                }

                {shape.set_id &&
                    this.renderThumbnails()
                }
            </div>
        )
    }
}

const StyledGrid = css(Grid)({
    marginTop: '40px',
    '.small': {
        ' img': {
            maxWidth: '100%',
        },
        textAlign: 'center',
        ':hover': {
            transform: "scale3d(1.15,1.15,1)",
            transition: "transform 0.3s",
            willChange: "transform",
            overflow: 'hidden',
        },
    },
    '.big': {
        textAlign: 'center',
        ' img': {
            maxWidth: '240px',
        },
    }
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        shapeSets: state.shapeSets,
        form: selectFormValues(state, getFormName(state.isAlt)),
    }
}

export default connect(mapStateToProps, {
    change,
    setActiveShapeId,
})(SetFilesSelect)
